<template>

  <popover-box ref="popover" :parent="parent" :direction="direction">
    <operator-selector :enableNot="enableNot" :enableMinus="enableMinus" v-on:select="selectOperator"></operator-selector>
  </popover-box>

</template>

<script>

import PopoverBox from './PopoverBox'
import OperatorSelector from './OperatorSelector'
import popoverContainerMixin from './popoverContainerMixin'

export default {
  mixins: [
    popoverContainerMixin
  ],
  props: {
    enableNot: {
      type: Boolean,
      default: true
    },
    enableMinus: {
      type: Boolean,
      default: true
    }
  },
  components: {
    PopoverBox, OperatorSelector
  },
  methods: {
    selectOperator (operator) {
      this.$emit('select', operator)
      setTimeout(() => this.dismiss(), 5)
    }
  }
}

</script>

<style lang="scss">

</style>



// WEBPACK FOOTER //
// OperatorPopover.vue?4f14f23a